<template>
  <v-layout row>
    <v-flex>
      <v-card>
        <v-toolbar color="secondary" dark>
          <v-toolbar-title>My Tasks</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn icon @click="loadTasks()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-toolbar>

        <v-list three-line>
          <template v-for="(item, index) in items">
            <v-list-item
              :key="item.title"
              avatar
              ripple
              @click="actionOnTask(item.action, item.postID)"
            >
                <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                    <v-list-item-subtitle>
                        {{ item.text }}
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <v-btn icon ripple>
                        <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>
            <v-divider
              v-if="index + 1 < items.length"
              :key="index"
            ></v-divider>
          </template>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import config from '@/config'
  import PostAPI from '../Post/postApi'

  export default {
    data () {
      return {
        items: []
      }
    },

    methods: {
      loadTasks() {
        this.items = [
          // default task for Influencer to submit
          // to do - Only show if the influnecer have assigned campaign or eligible to submit
        ]
        this.checkForPendingRelease()
      },
      actionOnTask(task, postID) {
        switch (task) {
          case 'viewPost':
            this.$router.push({path: '/posts/internal/pending-kobe', query: { action: 'view', id: postID }});
            break;
        }
      },
      checkForPendingRelease() {
        let status = config.postStatus.AD_STRATEGIST_PENDING
        PostAPI.getPost({status, page: 1})
          .then(response => {
            let posts = response.posts
            const pendingReleasePosts = posts.filter(item => item.waiting_release)
            if (pendingReleasePosts.length > 0) {
              this.items.push({
                action: 'viewPost',
                title: 'Pending your approval',
                text: `${pendingReleasePosts.length} draft(s) to release.`
              })
            }
          })
          .catch(err => {
            console.error(err);
          });
      }
    },
    mounted() {
      this.loadTasks()
    },
    computed: {
      currentUserID: function () {
        return this.$store.state.user.id
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SalePersonTasks.vue?b5672268